
// @ts-nocheck
import Vue from 'vue'
import AvatarPlaceholder from './SVGs/AvatarPlaceholder.vue'
import { firebase } from '../../../../firebase/firebaseConfig'
import { Representative } from '../../../../../../../Overarching Resources/TS/Survey/types'
const storageRef = firebase.storage().ref()

export default Vue.extend({
    data () {
        return {
            ppURLLocal: '',
            nameLocal: '',
            titleLocal: '',
            logoMessage: false,
            logoLoading: false,
            showProfileWarning: false
        }
    },
    props: {
          fieldAddress: Array 
    },
    created(): void {
        if (typeof this.field === 'object') {
            const theRep =  this.field as Representative
            this.ppURLLocal = theRep.profilePicture
            this.nameLocal = theRep.name
            this.titleLocal = theRep.title
        }
    },
    computed: {
        field: {
                get: function() {     
                    // @ts-ignore
                    return this.$store.getters['survey/stepField'](this.fieldAddress)
                },
                set: function(v) {
                    // @ts-ignore 
                    this.$store.commit('survey/CHANGE_FIELD', {
                        // @ts-ignore
                        fieldAddress: this.fieldAddress,
                        val: v
                    })
                }            
            }
    },
    watch: {
        ppURLLocal() {
            this.emitErrors()
            this.updateField()
        },
        nameLocal(v) {       
            this.emitErrors()                 
            this.updateField()
        },
        titleLocal(v) {
            this.emitErrors()
            this.updateField()
        }        
    },
    methods: {
        emitErrors() {
          setTimeout(() => {
            // @ts-ignore //errors not picked up
            if (this.errors.any()) {
                this.$emit("handleErrors", {fieldAddress: this.fieldAddress, hasErrors: true});
            } else {
                this.$emit("handleErrors", {fieldAddress: this.fieldAddress, hasErrors: false});
            }
            }, 1);
        },
        updateField() {
            if (this.ppURLLocal.trim() === '' && this.nameLocal.trim() === '' && this.titleLocal.trim() === '') {
                this.field = false
            } else {
                this.field = {
                    name: this.nameLocal,
                    title: this.titleLocal,
                    profilePicture: this.ppURLLocal            
                } as Representative                
            }
        },
        selectFile() {
            this.$refs.logoInput.click()
        },
        filesChange(target) {
        // NEED TO CROSS BROWSER TEST/READ UP ON FILE API ON BROWSERS/SUPPORT
        //noconsoleconsole.log('checking image validity..')
        this.message = false
        this.logoMessage = false
      if (typeof target[0] !== 'undefined') {
        let validation = this.validateLogo(target[0])
        let imgName = this.$store.state.dash.viewData.business.businessInfo.businessName + (new Date().getTime() / 1000)
        imgName = (imgName.replace(/[`~±!@#$%^&*()_|+\-=÷¿?;:'",.<> \{\}\[\]\\\/]/gi, '')).toLowerCase()
        imgName = imgName.replace(/[^\w\s]/gi, '')
        //console.log(storageRef)
        if (validation.passed) {
          let imageRef = storageRef.child('businessrepresentatives/' + imgName)
          this.logoLoading = true
          this.logoMessage = ''
          //noconsoleconsole.log('uploading image..')
          imageRef.put(target[0]).then((snapshot) => {
            //noconsoleconsole.log('umage uploaded')
            snapshot.ref.getDownloadURL().then((dURL) => {
              //noconsoleconsole.log(dURL)
              this.logoUploaded = true
              this.logoLoading = false
              this.message = false
              this.logoButtonText = target[0].name
              this.ppURLLocal = dURL
              this.$vs.notify({
                    title: 'Representative picture uploaded',
                    text: 'Remember to save your welcome settings by selecting the Check (✔️) button for your Welcome step.',
                    color: 'success',
                    time: 15000,
                    iconPack: 'feather',
                    icon:'icon-check'})
            }).catch((e) => {
              //noconsoleconsole.log(e)
              this.logoLoading = false
              this.logoMessage = 'We couldn\'t upload your logo, please ensure it\'s not larger than 1MB and either a JPEG, GIF or PNG file.'
            })
          }).catch((e) => {
            //noconsoleconsole.log(e)
            this.logoMessage = 'We couldn\'t upload your logo, please ensure it\'s not larger than 1MB and either a JPEG, GIF or PNG file.'
            this.logoLoading = false
          })
        } else {
          this.logoMessage = validation.reason
        }
      }
    },
    validateLogo(file) {
      if (typeof file.size !== 'undefined') {
        if (file.size > 500000) {
          return {
            passed: false,
            reason: 'Your logo file may not be larger than 500Kb in size.'
          }
        }
      }
      if (typeof file.size !== 'undefined') {
        if ((file.type !== 'image/png') && (file.type !== 'image/jpeg') && (file.type !== 'image/gif')) {
          return {
            passed: false,
            reason: 'Your logo file needs to be a JPG, GIF or PNG file extension.'
          }
        }
      }
      return {
        passed: true,
        reason: ''
      }
    },
    },
    components: {
        AvatarPlaceholder
    }
})

